import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Area, AreaFiltro } from "../../types/Area";


interface AreaState {
    areaList: Area[];
    areaSelected: Area;
    filtro: AreaFiltro;
    loading: boolean;
    errors: any;
    error: boolean,
    guardado: boolean,
}

export const areaInitial: Area = {
    nombre: "",
    descripcion: "",
    activo: true,
}

export const areaFiltroInitial: AreaFiltro = {
    nombre: "",
    activo: null,
}

const initialState: AreaState = {
    areaList: [],
    areaSelected: areaInitial,
    filtro: areaFiltroInitial,
    loading: false,
    errors: [],
    error: false,
    guardado: false
}

const areaSlice = createSlice({
    name: 'area',
    initialState,
    reducers: {
        addArea: (state, data: PayloadAction<Area>): void => {
            state.areaSelected = areaInitial;
            state.error = false;
            state.guardado = true;
        },
        isLoading: (state, data: PayloadAction<boolean>): void => {
            state.loading = data.payload;
        },
        loadDataArea: (state, data: PayloadAction<Area>): void => {
            state.areaSelected = data.payload;
            state.error = false;
        },
        loadListArea: (state, data: PayloadAction<Area[]>): void => {
            state.areaList = data.payload;
        },
        loadingError: (state, data: PayloadAction<any>): void => {
            state.errors = data.payload;
            state.error = true;
        },
        visibleError: (state, data: PayloadAction<boolean>): void => {
            state.error = data.payload;
        },
        setGuardado: (state, data: PayloadAction<boolean>): void => {
            state.guardado = data.payload;
        },
        loadDataFiltro: (state, data: PayloadAction<AreaFiltro>): void => {
            state.filtro = data.payload;
        },
    }
});
export const {
    addArea,
    isLoading,
    loadDataArea,
    loadListArea,
    loadingError,
    visibleError,
    setGuardado,
    loadDataFiltro
} = areaSlice.actions;

export default areaSlice.reducer;
